import { TranslationSegment } from '@/models/TranslationSegment';
import { TranslationConfiguration } from '@/models/TranslationConfiguration';
import { ExternalTranslationResponse } from '@/models/ExternalTranslationResponse';

import { notifyWarning } from '@/services/notificationService'
import { notifyMaintenance } from '@/utils/httpClient'

import { segmentsApi } from '@/api/segmentsApi';
import { translationApi } from '@/api/translationApi';
import { externalTranslationApi } from '@/api/externalTranslationApi';

export class segmentApiService {
    private static instance: segmentApiService;

    public static getInstance(): segmentApiService {
        if (!segmentApiService.instance) {
            segmentApiService.instance = new segmentApiService();
        }
        return segmentApiService.instance;
    }

    async saveSegmentChnages(translationSegment: TranslationSegment) {
        segmentsApi.updateTranslationState(translationSegment);
    }

    async saveSegmentState(translationSegment: TranslationSegment) {
        segmentsApi.updateTranslationState(translationSegment);
    }

    async translateSegment(translationSegment: TranslationSegment, configuration: TranslationConfiguration) {
        //TODO: create model
        const request = {
            SegmentId: translationSegment.translationSegmentId,
            Source: translationSegment.sourceData.text,
            Config: configuration
        }

        const responce = await translationApi.getTranslation(request);
        return responce as TranslationSegment;
    }

    async reloadSegmentTranslations(translationSegment: TranslationSegment, configuration: TranslationConfiguration) {
        //TODO: create model
        const request = {
            SegmentId: translationSegment.translationSegmentId,
            Source: translationSegment.sourceData.text,
            Config: configuration
        }

        const responce = await translationApi.reloadSegmentTranslations(request);
        return responce as TranslationSegment;
    }

    async translateExternallySegment(translationSegment: TranslationSegment, configuration: TranslationConfiguration) {
        //TODO: create model
        const request = {
            SegmentId: translationSegment.translationSegmentId,
            Source: translationSegment.sourceData.text,
            Config: configuration
        }

        try {
            const responce = await externalTranslationApi.translateSegment(request);
            return responce as ExternalTranslationResponse;
        }
        catch (error: any) {
            console.log("External translation error", error);
            if (!notifyMaintenance(error)) {
                notifyWarning("API error", "Try again later, or contact LoopWord");
            }
            return null;
        }
    }

    async addNewTranslationStyled(translationSegment: TranslationSegment, configuration: TranslationConfiguration) {
        //TODO: create model

        const request = {
            SegmentId: translationSegment.translationSegmentId,
            Source: translationSegment.sourceData.text,
            Target: translationSegment.draftData,
            Config: configuration
        }

        const responce = await translationApi.saveTranslationStyled(request);

        return responce as TranslationSegment;
    }

    async updateTranslationStyled(translationSegment: TranslationSegment, configuration: TranslationConfiguration) {
        //TODO: create model

        const request = {
            SegmentId: translationSegment.translationSegmentId,
            Source: translationSegment.sourceData.text,
            TargetOld: translationSegment.segmentTranslation?.targetSegment,
            Target: translationSegment.draftData,
            Config: configuration
        }

        const responce = await translationApi.updateTranslationStyled(request);
        return responce as TranslationSegment;
    }

    async updateSegmentStyles(translationSegment: TranslationSegment) {
        //TODO: create model

        const request = {
            SegmentId: translationSegment.translationSegmentId,
            EntityId: translationSegment.segmentTranslation?.entryId,
            SegmentStyle: translationSegment.draftData.delta,
        }

        const responce = await translationApi.updateSegmentStyles(request);
        return responce as TranslationSegment;
    }

    async getTerminology(configuration: any, termsArray: any) {
        //TODO: create model

        const data = {
            SubjectId: configuration.subjectId,
            SourceLanguageId: configuration.sourceLanguageId,
            TargetLanguageId: configuration.targetLanguageId,
            SearchTerms: termsArray
        };

        return await translationApi.getTerminology(data);
    }
}